import { Chip, Flex } from '@servicetitan/anvil2';
import { Calculation, PaymentStructure } from '@servicetitan/financing-api-client';
import { core } from '@servicetitan/anvil2/token';
import { plansTag } from './PlansTags.module.scss';

interface PlanTagsProps {
    plan: Calculation;
    showLowestPayment?: boolean;
}

export const PlanTags = ({ plan, showLowestPayment = true }: PlanTagsProps) => {
    const lowestColor = core.primitive.ColorGreen50.value;
    const paymentStructureColor = core.primitive.ColorBlue50.value;
    // `Calculation` (fin-plans-api) and `PaymentStructure` (financing-api) are two
    // identically-valued generated enums; reconcile them so the comparison is enum-type-safe.
    const paymentStructure = plan.paymentStructure as PaymentStructure;

    return (
        <Flex gap="1" wrap="wrap">
            {showLowestPayment && plan.hasLowestPayment && plan.hasLowestRate && (
                <Chip className={plansTag} label="Lowest Payment & APR" color={lowestColor} />
            )}
            {showLowestPayment && plan.hasLowestPayment && !plan.hasLowestRate && (
                <Chip className={plansTag} label="Lowest Payment" color={lowestColor} />
            )}
            {showLowestPayment && !plan.hasLowestPayment && plan.hasLowestRate && (
                <Chip className={plansTag} label="Lowest APR" color={lowestColor} />
            )}
            {paymentStructure === PaymentStructure.Promotional && (
                <Chip className={plansTag} label="Promotional" color={paymentStructureColor} />
            )}
            {paymentStructure === PaymentStructure.NoInterest && (
                <Chip className={plansTag} label="0% APR" color={paymentStructureColor} />
            )}
            {paymentStructure === PaymentStructure.MixedInterest && (
                <Chip className={plansTag} label="Mixed Interest" color={paymentStructureColor} />
            )}
            {(paymentStructure === PaymentStructure.DeferredInterest ||
                paymentStructure === PaymentStructure.DeferredInterestAndPrincipal) && (
                <Chip
                    className={plansTag}
                    label="Deferred Interest"
                    color={paymentStructureColor}
                />
            )}
            {paymentStructure === PaymentStructure.StandardInstallment && (
                <Chip className={plansTag} label="Fixed Rate" color={paymentStructureColor} />
            )}
        </Flex>
    );
};
